import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import type { QueryOpts } from "./useTrackingEvents";

export interface InactiveUser {
	user_id: string;
	full_name: string | null;
	job_title: string | null;
	org_team_level_one: string | null;
	last_active_at: string | null;
	first_seen_at: string | null;
	lifetime_event_count: number;
}

export interface InactiveUsersResponse {
	since_threshold: string;
	total_count: number;
	users: InactiveUser[];
}

export interface InactiveUsersArgs {
	since?: Date;
	limit?: number;
}

const fetchInactive = async (
	args: InactiveUsersArgs
): Promise<InactiveUsersResponse> => {
	const { data } = await cmsClient.get<InactiveUsersResponse>(
		"/tracking/users/inactive/",
		{
			params: {
				...(args.since ? { since: args.since.toISOString() } : {}),
				limit: args.limit ?? 100
			}
		}
	);
	return data;
};

const useTrackingInactiveUsers = (
	args: InactiveUsersArgs,
	options?: QueryOpts
) =>
	useQuery(
		[
			"tracking",
			"inactive-users",
			args.since?.toISOString() ?? "default",
			String(args.limit ?? 100)
		],
		() => fetchInactive(args),
		options
	);

export default useTrackingInactiveUsers;
